import { render, staticRenderFns } from "./Promotions.vue?vue&type=template&id=48e0aa68&"
import script from "./Promotions.vue?vue&type=script&lang=js&"
export * from "./Promotions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports